var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.42C0 7.58349 7.16344 0.420044 16 0.420044C24.8366 0.420044 32 7.58349 32 16.42C32 25.2566 24.8366 32.42 16 32.42C7.16344 32.42 0 25.2566 0 16.42Z",
    fill: "#D5DAF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1104 22.42C14.8771 22.42 14.6971 22.2134 14.7304 21.98L15.3304 17.7534H12.9971C12.4104 17.7534 12.7771 17.2534 12.7904 17.2334C13.6304 15.7467 14.8904 13.5467 16.5571 10.6134C16.6237 10.4934 16.7571 10.42 16.8904 10.42C17.1237 10.42 17.3037 10.6267 17.2704 10.86L16.6704 15.0867H19.0104C19.2771 15.0867 19.4237 15.2134 19.2771 15.5267C17.0837 19.3534 15.8104 21.5867 15.4437 22.2267C15.3771 22.3467 15.2504 22.42 15.1104 22.42Z",
    fill: "#171D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskProfile);
export default __webpack_public_path__ + "static/media/riskProfile.1890818c1604b7813a951cffb45dd51f.svg";
export { ForwardRef as ReactComponent };